import axios from 'axios';
import { getAuth } from 'firebase/auth';

export const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const urlFile = `${baseURL}/files`;

const api = axios.create({
    baseURL: baseURL,
});

const isBillingBlockedError = (error: any) => {
    if (error?.response?.status !== 403) return false;

    if (error?.response?.data?.code === 'BILLING_BLOCKED') {
        return true;
    }

    const message = String(error?.response?.data?.message || '').toLowerCase();
    return (
        message.includes('periodo de teste') ||
        message.includes('teste expirado') ||
        message.includes('ativar o pagamento')
    );
};

api.interceptors.request.use(
    async (config) => {
        const auth = getAuth();
        const currentUser = auth.currentUser;

        if (!!currentUser) {
            try {
                const token = await currentUser.getIdToken();

                if (token) {
                    // Salva no localStorage
                    localStorage.setItem("authToken", token);
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
            } catch (error) {
                console.error("Erro ao obter token, tentando recuperar do localStorage", error);

                // Recupera o token do localStorage em caso de erro
                const cachedToken = localStorage.getItem("authToken");
                if (cachedToken) {
                    config.headers["Authorization"] = `Bearer ${cachedToken}`;
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const isPlanFeatureBlockedError = (error: unknown) =>
    (error as any)?.response?.data?.code === 'PLAN_FEATURE_BLOCKED';

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isPlanFeatureBlockedError(error)) {
            return Promise.reject(error);
        }

        if (isBillingBlockedError(error)) {
            const blockedPath = '/billing-blocked';
            const regularizationPaths = [blockedPath, '/meu-plano'];
            if (!regularizationPaths.includes(window.location.pathname)) {
                window.location.href = blockedPath;
            }
        }

        return Promise.reject(error);
    }
);

export { api };
